import axios from 'axios';
import {
  ACCOMMODATION_DETAIL,
  ACCOMMODATION_EXPORT,
  ACCOMMODATION_LIST,
  ACCOMMODATION_PAYMENT_REVERIFY,
  ROOM_BOOKING_CREATE_INVITE,
  ROOM_BOOKING_INVITES_LIST,
  ROOM_BOOKING_INVITE_DETAIL_PUBLIC
} from '../../constant/API constant';

export const Accommodation_List = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${ACCOMMODATION_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const VerifiedPayment = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${ACCOMMODATION_PAYMENT_REVERIFY}`, paramsObj, {
    headers: { Authorization: jwt_token }
  });
};
export const Accommodation_Detail = (booking_id) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${ACCOMMODATION_DETAIL}`, {
    headers: { Authorization: jwt_token },
    params: { booking_id }
  });
};

export const Accommodation_Export = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${ACCOMMODATION_EXPORT}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj,
    responseType: 'arraybuffer'
  });
};

export const Create_Booking_Invite = (data) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${ROOM_BOOKING_CREATE_INVITE}`, data, {
    headers: { Authorization: jwt_token }
  });
};

export const Get_Booking_Invites = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${ROOM_BOOKING_INVITES_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const Get_Booking_Invite_Detail_Public = (token) => {
  return axios.get(`${process.env.REACT_APP_API_URL}${ROOM_BOOKING_INVITE_DETAIL_PUBLIC}/${token}`);
};

export const Delete_Booking_Invite = (inviteId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(`${process.env.REACT_APP_API_URL}${ROOM_BOOKING_CREATE_INVITE}/${inviteId}`, {
    headers: { Authorization: jwt_token }
  });
};

